import { createAsyncThunk, addListener } from '@reduxjs/toolkit';
import { BaseApiResponse } from 'common/types';
import { wrapRequest } from "common/utils";
import {
    settingService,
    accountSvc,
    scenarioSvc,
} from "services/serviceStorage";
import { FeaturesConfiguration, CurrentUser } from './types';
import some from 'lodash/some';
import { actions } from "./reducer";

export const getFeaturesConfiguration = createAsyncThunk<FeaturesConfiguration, void>(
    'layout/getFeaturesConfiguration',
    async () => {
        const { data } = await wrapRequest<BaseApiResponse<FeaturesConfiguration>>({
            handler: () => settingService.getFeaturesConfiguration(),
            showNotifications: true
        });

        return data!.result;
    }
);

export const fetchUser = createAsyncThunk<CurrentUser, void>(
    'layout/fetchUser',
    async () => {
        const { data } = await wrapRequest<CurrentUser>({
            handler: () => accountSvc.get(),
            showNotifications: true
        });

        return { ...data!, isSuperAdmin: some(data!.userRoles, r => r == "superadmin") };
    }
);

export const fetchScenario = createAsyncThunk<any, string>(
    'layout/fetchScenario',
    async (scenarioId) => {
        const { data } = await wrapRequest<BaseApiResponse<any>>({
            handler: () => scenarioSvc.getScenario(Number(scenarioId)),
            showNotifications: true
        });

        return data!.result;
    }
);

export const askConfirmation = createAsyncThunk<boolean | undefined, { message: string; title?: string }>(
    "layout/askConfirmation",
    async (payload, { dispatch }) => {
        dispatch(actions.showConfirmation(payload));

        return new Promise<boolean | undefined>((resolve) => {
            dispatch(
                addListener({
                    actionCreator: actions.hideConfirmation,
                    effect: (action, api) => {
                        api.unsubscribe();
                        resolve(action.payload);
                    },
                })
            );
        });
    }
);